import React from "react"
import "../styles/header.scss"

const Header = () => {
    return (
        <div className="header">
            <div className="header-title-wrap">
                <h1 className="header-title-wrap-title">COVID-19 Coronavirus Global Data (1st Phase)</h1>
            </div>   
        </div>
    )
}

export default Header